import React from 'react';
import type { PublicFiche } from '../types';
import { FicheCardBase } from './FicheCardBase';

interface FicheCardProps {
  fiche:      PublicFiche;
  showScore?: boolean;
  compact?:   boolean;
}

/**
 * Carte générique — backward compatible avec l'ancienne API.
 * Utilisée dans PublicBrowse et Homepage.
 */
export const FicheCard = ({ fiche, showScore = false, compact = false }: FicheCardProps) => (
  <FicheCardBase fiche={fiche} showScore={showScore} compact={compact} />
);